import {AclFilterOverview} from "../listpage/FilterRenderer";
import { facetToFilterGroup } from './Util';

class FactfinderFacetOverview extends AclFilterOverview {

	async update( { facets, totalHits, searchParams } ) {
		this.articleCount = totalHits;
		this.facets = facets;
		this.filterJSON = this.facets.map( facet => facetToFilterGroup( facet ) );
		this.searchParams = searchParams;
		this.initialSearchParams ??= searchParams;

		return this.renderOverview( '#', this.filterJSON );
	}

	onSubmit() {
		const searchParams = this.searchParams;

		if ( this.searchParams !== this.initialSearchParams ) {
			// Dispatch Submit to Controller.
			this.closeOverview();
			this.overviewEl.dispatchEvent( new CustomEvent( 'change.ff', { bubbles: true, detail: { searchParams } } ) );
		}
	}

	onReset() {
		this.overviewEl.dispatchEvent( new CustomEvent( 'change.ff', { bubbles: true, detail: { searchParams: this.initialSearchParams } } ) );
	}

	openChip( identifier ) {
		const Controller = this.getController();
		const chip = Controller.getChip( identifier );
		if ( chip ) {
			const facet = this.facets.find( facet => facet.associatedFieldName === identifier );
			chip.facet = facet;
			chip.searchParams = this.searchParams;

			return chip.renderChip( facet, 'overview' ).then( () => {
				chip.openFromOverview();
			} )
		}
	}

	async updateData( { facets, totalHits, searchParams } ) {
		this.facets = facets;
		this.articleCount = totalHits;
		this.searchParams = searchParams;

		return await this.renderOverview( '#', this.facets.map( facet => facetToFilterGroup( facet ) ) );
	}
}


export default FactfinderFacetOverview;
